export default __webpack_public_path__ + "static/media/11-8.f70fb8ec.png";